import {EsquireClient} from "@/types/clients/esquire";
import GetPaymentInfoResponseBody
  from "@/types/clients/esquire/data/payment/get-payment-info-response-body";
import PostPaymentData from "@/types/clients/esquire/requests/payment/post-payment-data";
import {PaymentRequest} from "@/interfaces/esquire/payment-request";

export default class StartReservationPayment implements PaymentRequest{
  constructor(private client: EsquireClient) {}

  public async send(payment: PostPaymentData) {

    const url = await this.client.fetchUrlFromSession("start-reservation-payment");

    const response = await this.client.fetch(
      () => new URL(url), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payment.toJsonObject())
      }
    );

    if (!response.ok) {
      await this.client.logOutIfForbidden(response.status);
      throw new Error("Failed to initiate payment");
    }

    const responseData = await response.json();
    return new GetPaymentInfoResponseBody(responseData);
  }
}
